import { post, get } from './request'

export let loadRoute = (payload, success, failure) => get(`/api/route/${payload}`, success, failure)